<mat-form-field>
  <mat-label>{{label}}</mat-label>
  <mat-select [(ngModel)]="data"
    (selectionChange)="onFocusOut()" name="selectWithSearch">
    <mat-option>
      <ngx-mat-select-search
        [(ngModel)]="searchCtrl"
        [placeholderLabel]="'Search...'"
        [noEntriesFoundLabel]="'Not found'"
        name="search"
      ></ngx-mat-select-search>
    </mat-option>
    @for (item of list | sourcesFilter: searchCtrl; track item) {
      <mat-option [value]="item">
        {{item.name}}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
